import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";

interface IFeatureMasterServiceProps extends ICommonServiceProps {
  featureCategoryIdProp?: number | null;
}
export const useGetAllFeaturesService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  cacheKeys = [],
  filters = {},
  featureCategoryIdProp,
}: IFeatureMasterServiceProps) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const featureCategoryId =
    featureCategoryIdProp || +urlQueries["feature-category-id"] || "";
  const created_between = urlQueries["created_between"] || "";
  const productId = urlQueries["product-id"] || "";

  const allFeaturesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.FEATURES,
      page,
      debouncedQuery,
      per_page,
      featureCategoryId,
      created_between,
      productId,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.FEATURES,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[feature_category_id]": featureCategoryId,
          "filter[created_between]": created_between,
          "filter[product_id]": productId,
          page,
          per_page,
          include: "featureCategory.segment,product",
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    states: { searchQuery, setSearchQuery },
    service: { allFeaturesService },
  };
};
